import React, { Fragment } from 'react';
import {
	ShowController,
	ShowView,
	RichTextField,
	DateField,
	TextField,
	useTranslate,
} from 'react-admin';
import { Typography, makeStyles, Chip } from '@material-ui/core';
import PaymentInstrumentShowActions from './PaymentInstrumentShowActions';
import PaymentInstrumentDocumentList from '../paymentInstrumentDocuments/PaymentInstrumentDocumentList';
import { Grid, GridShowLayout } from '../../components/wrapper';
import { LinkField } from '../../components/fields';

const useStyles = makeStyles({
	titles: {
		marginTop: 10,
		marginBottom: 20
	},
	show: {
		marginBottom: 24
	},
	list: {
		marginBottom: 24
	},
	chip: {
		marginRight: 5,
	},
	wrapText: {
		wordBreak: 'break-all'
	}
});

const CapabilitiesField = ({ record, source }) => {
	const classes = useStyles();
	const array = record[source];
	if (typeof array === 'undefined' || array === null || array.length === 0) {
		return <div />;
	} else {
		return (
			<React.Fragment>
				{array.map(capability => <Chip label={capability} key={capability} className={classes.chip} />)}
			</React.Fragment>
		);
	}
};
CapabilitiesField.defaultProps = {
	addLabel: true
};

const PaymentInstrumentShow = props => {
	const translate = useTranslate();
	const classes = useStyles();
	return (
		<Fragment>
			<ShowController {...props}>
				{controllerProps => (
					<ShowView actions={<PaymentInstrumentShowActions />} {...props} {...controllerProps} className={classes.show}>
						<GridShowLayout>
							<Grid container spacing={2}>
								<Grid item xs={12} md>
									<TextField source="paymentInstrumentId" />
									<TextField source="displayValue" />
									<DateField source="creationDateTime" showTime />
									<TextField source="paymentInstrumentType" />
									<TextField source="paymentInstrumentStatus" />
									<TextField source="paymentInstrumentVerificationStatus" />
									<LinkField source="walletId" type="Wallet" />
									<TextField source="searchValue" className={classes.wrapText} />
									<CapabilitiesField source="paymentInstrumentCapabilities" />
									<RichTextField source="additionalData" />
								</Grid>
								<Grid item xs={12} md>
									{controllerProps.record &&
										controllerProps.record.publicPaymentInstrumentInfo &&
										controllerProps.record.publicPaymentInstrumentInfo.owner &&
										<TextField source="publicPaymentInstrumentInfo.owner" />
									}
									{controllerProps.record &&
										controllerProps.record.publicPaymentInstrumentInfo &&
										controllerProps.record.publicPaymentInstrumentInfo.countryCode &&
										<TextField source="publicPaymentInstrumentInfo.countryCode" />
									}
									{controllerProps.record &&
										controllerProps.record.publicPaymentInstrumentInfo &&
										controllerProps.record.publicPaymentInstrumentInfo.bic &&
										<TextField source="publicPaymentInstrumentInfo.bic" />
									}
									{controllerProps.record &&
										controllerProps.record.publicPaymentInstrumentInfo &&
										controllerProps.record.publicPaymentInstrumentInfo.iban &&
										<TextField source="publicPaymentInstrumentInfo.iban" />
									}
									{controllerProps.record &&
										controllerProps.record.publicPaymentInstrumentInfo &&
										controllerProps.record.publicPaymentInstrumentInfo.scheme &&
										<TextField source="publicPaymentInstrumentInfo.scheme" />
									}
									{controllerProps.record &&
										controllerProps.record.publicPaymentInstrumentInfo &&
										controllerProps.record.publicPaymentInstrumentInfo.maskedCardNumber &&
										<TextField source="publicPaymentInstrumentInfo.maskedCardNumber" />
									}
									{controllerProps.record &&
										controllerProps.record.publicPaymentInstrumentInfo &&
										controllerProps.record.publicPaymentInstrumentInfo.validToMonth &&
										<TextField source="publicPaymentInstrumentInfo.validToMonth" />
									}
									{controllerProps.record &&
										controllerProps.record.publicPaymentInstrumentInfo &&
										controllerProps.record.publicPaymentInstrumentInfo.validToYear &&
										<TextField source="publicPaymentInstrumentInfo.validToYear" />
									}
								</Grid>
							</Grid>
						</GridShowLayout>
					</ShowView>
				)}
			</ShowController>
			<Typography className={classes.titles} variant="h5">
				{translate('resources.paymentInstrumentDocuments.name')}
			</Typography>
			<PaymentInstrumentDocumentList
				perPage={5}
				{...props}
				basePath={'/paymentInstrumentDocuments'}
				resource={'paymentInstrumentDocuments'}
				title=" "
				filter={{ id: props.id }}
				className={classes.list}
			/>
		</Fragment>
	);
};

export default PaymentInstrumentShow;
